import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"


export const sendEmailReq = createAsyncThunk('documents/resendSignDocument', async (params, { rejectWithValue }) => {
  try {
    const { userId } = params
    const { data } = params
    const response = await apiRequest.post(`/mails/users/${userId}`, data)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message
    return rejectWithValue(errorMessage)
  }
})

export const getEmailsReq = createAsyncThunk('documents/getDocuments', async ({
                                                                                limit,
                                                                                offset,
                                                                                userId,
                                                                                searchQuery,
                                                                                inbox
                                                                              }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/mails/users/${userId}`, { params: { limit, offset, searchQuery, inbox } })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to remove Bank method'
    return rejectWithValue(errorMessage)
  }
})

export const getEmailInfoReq = createAsyncThunk('documents/getDocuments', async ({
                                                                                   letterId, userId
                                                                                 }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/mails/users/${userId}/letters/${letterId}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to remove Bank method'
    return rejectWithValue(errorMessage)
  }
})

export const getTemplatesReq = createAsyncThunk('documents/getTemplatesReq', async ({
                                                                                      type
                                                                                    }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/letters/templates/${type}/dropdown`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to remove Bank method'
    return rejectWithValue(errorMessage)
  }
})

export const getTemplateReq = createAsyncThunk('documents/getTemplateReq', async ({
                                                                                    templateId, userId
                                                                                  }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/letters/templates/${templateId}/users/${userId}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to remove Bank method'
    return rejectWithValue(errorMessage)
  }
})


export const getSmsReq = createAsyncThunk('documents/getSmsReq', async ({
                                                                          userId, searchQuery
                                                                        }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/sms/users/${userId}`, { params: { limit: 1000, searchQuery } })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to remove Bank method'
    return rejectWithValue(errorMessage)
  }
})


export const sendSmsReq = createAsyncThunk('documents/sendSmsReq', async ({
                                                                            message, userId,
                                                                          }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/sms/users/${userId}`, { message })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to send the text message'
    return rejectWithValue(errorMessage)
  }
})